import RequestTypes from '../request-types'
import Request from '../request'

class PingRequest extends Request {
    constructor() {
        super({
            req: RequestTypes.PING,
            req_id: 0,
        });
    }
}

export default PingRequest;